module.exports = __webpack_public_path__ + "static/media/hpb-overview.c03fbb01.png";